import Vue from "vue";
import vuetify from "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueAnalytics from "vue-analytics";
import api from "./api";
import {
  storeAssets,
  storeEntries,
  deleteAssets,
  deleteEntries
} from "./utils/contentfulParser";

Vue.config.productionTip = false;

Vue.prototype.$contentful = api;

store.set(
  "analyticsOn",
  JSON.parse(localStorage.getItem("ANALYTICS_ACCEPTED"))
);

Vue.mixin({
  data() {
    return {
      refreshing: false,
      analyticsAccepted: false
    };
  },
  methods: {
    pageTrack(pagePath, pageTitle) {
      this.$ga.page({
        page: pagePath,
        title: pageTitle
      });
    },
    refreshData() {
      console.log("refreshData");
      this.refreshing = true;

      let syncToken = store.get("syncToken");
      // console.log("syncToken", syncToken);

      let initial = !syncToken;

      let syncParams = {
        // id: null,
        initial: initial,
        nextSyncToken: syncToken,
        resolveLinks: false
      };

      // console.log("syncParams", syncParams);

      this.$contentful
        .sync(syncParams)
        .then(async resp => {
          storeAssets(resp.assets);

          storeEntries(resp.entries);

          deleteEntries(resp.deletedEntries);

          deleteAssets(resp.deletedAssets);

          store.set("syncToken", resp.nextSyncToken);
          this.refreshing = false;
        })
        .catch(() => {});
    }
  }
});

Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GA_ID,
  // router,
  set: [
    { field: "appName", value: process.env.VUE_APP_NAME },
    { field: "appVersion", value: process.env.VUE_APP_VERSION }
  ],
  disabled: () => {
    let x = store.get("analyticsOn");
    return x !== true;
  }
  // debug: {
  //   sendHitTask: !/localhost/i.test(window.location.hostname)
  // }
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
